import { Link } from "react-router-dom";
import { mediaUrl } from "../../lib/api";
import { formatDate } from "../../lib/format";
import { useLang } from "../../context/LanguageContext";
import { ArrowUpRight } from "lucide-react";

export function ArticleCard({ article, index = 0 }) {
  const { lang } = useLang();
  return (
    <article
      data-testid={`article-card-${article.slug}`}
      className="group flex flex-col bg-[#E9EFFA] rounded-sm overflow-hidden fade-up"
      style={{ animationDelay: `${index * 0.07}s` }}
    >
      <Link to={`/blog/${article.slug}`} className="block relative overflow-hidden aspect-[16/10]">
        {article.featured_image ? (
          <img
            src={mediaUrl(article.featured_image)}
            alt={article.featured_image_alt || article.h1}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        ) : (
          <div className="h-full w-full bg-[#0B1220]" />
        )}
        {article.category && (
          <span className="absolute top-4 left-4 bg-[#F4F8FF]/90 backdrop-blur px-3 py-1 text-[11px] uppercase tracking-[0.16em] text-[#1452F0] font-semibold">
            {article.category}
          </span>
        )}
      </Link>
      <div className="flex flex-col flex-1 p-6">
        <Link to={`/blog/${article.slug}`}>
          <h3 className="font-heading text-xl md:text-2xl leading-snug text-[#0B1220] group-hover:text-[#1452F0] transition-colors">
            {article.h1}
          </h3>
        </Link>
        {article.subtitle && (
          <p className="mt-2 text-sm text-[#5C6678] font-light line-clamp-3">{article.subtitle}</p>
        )}
        <div className="mt-auto pt-5 flex items-center justify-between text-xs text-[#5C6678]">
          <span>{formatDate(article.published_at || article.created_at, lang)}</span>
          <Link
            to={`/blog/${article.slug}`}
            data-testid={`article-read-${article.slug}`}
            className="inline-flex items-center gap-1 text-[#1452F0] font-medium"
          >
            Leggi <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </article>
  );
}
